import {FormFields, StoredFormFields} from '../types';

/**
 * Format values before storing:
 * - Neither `localStorage` or `indexedDB` support storing `Set` objects
 * - Covert `Set` values to `Array`
 */
export const prepareToSave = (
  values: Partial<FormFields>,
): Partial<StoredFormFields> => {
  const {goals, assets, ...rest} = structuredClone(values);

  return {
    ...rest,
    ...(goals?.size ? {goals: Array.from(goals)} : {}),
    ...(assets?.size ? {assets: Array.from(assets)} : {}),
  };
};

/**
 * Format values before storing:
 * - Neither `localStorage` or `indexedDB` support storing `Set` objects
 * - Covert `Array` values back to `Set`
 */
export const prepareFromRead = (
  values: Partial<StoredFormFields>,
): Partial<FormFields> | undefined => {
  if (typeof values !== 'object' || !Object.keys(values || {}).length) {
    return undefined;
  }

  const {goals, assets, ...rest} = structuredClone(values);

  return {
    ...rest,
    ...(goals ? {goals: new Set(goals)} : {}),
    ...(assets ? {assets: new Set(assets)} : {}),
  };
};
